import {UICoinsController} from '../../../shared/scripts/ui_coins/UICoinsController.ts'
import {setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils.ts'
import {UIMSceneEnum} from '../../../../shared/enums/UIMSceneEnums.ts'
import {type UIMSceneController} from '../ui_html/UIMSceneController.ts'
import {AudioManager, AudioType} from '@colonist/audio'

export class UIMCoinsController extends UICoinsController {
    private readonly sceneController: UIMSceneController

    constructor(sceneController: UIMSceneController) {
        super()
        this.sceneController = sceneController
    }

    protected initCoinClick() {
        setElementOnClick(this.headerCoinsContainer, () => {
            AudioManager.play(AudioType.Click)
            this.sendCoinClickAnalytic()
            this.sceneController.loadScene(UIMSceneEnum.Store)
        })
        this.headerCoinsContainer.style.transition = ''
    }

    protected setCoins(coinAmount: number) {
        super.setCoins(coinAmount)
        this.headerCoinsContainer.style.maxWidth = this.headerCoinsContainer.clientWidth + 'px'
    }
}
